import { FieldType } from '@wix/wix-data-schema-types'
import { STYLABLE_BUTTON_ROLE } from '@wix/wix-data-client-common-standalone'
import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'

const {
  text,
  image,
  number,
  date,
  dateTime,
  url,
  document,
  video,
  stringArray,
  address,
} = FieldType

export default (): DataBindingComponentModel => ({
  componentName: 'Element_Name_Stylable_Button',
  isConnectGfppEnabled: true,
  supportsDefaultSelectedDataset: true,
  compactErrorPanel: false,
  panel: {
    height: 467,
    title: 'Connect_Panel_Title_Button',
    helpId: 'f3e95690-e2c0-4172-bd5f-f6b77335279d',
  },
  sections: [
    {
      role: STYLABLE_BUTTON_ROLE,
      bindings: [
        {
          title: 'Connect_Panel_Connect_Link_Action',
          prop: 'link',
          event: 'onClick',
          supportedFieldTypes: [document, url, image, video],
          defaultFieldType: url,
          supportPageLinks: true,
          supportsActions: true,
          supportsReferenceFields: true,
          supportsPostSubmit: true,
          supportsUrlTarget: true,
          supportsUrlRel: true,
          requiresPrimaryConnection: true,
        },
        {
          title: 'Connect_Panel_Connect_Label_Label',
          prop: 'label',
          supportedFieldTypes: [
            text,
            number,
            date,
            dateTime,
            address,
            stringArray,
          ],
          defaultFieldType: text,
          supportsReferenceFields: true,
        },
      ],
      manifest: {
        gfpp: {
          desktop: {
            iconButtons: {
              link: {
                behavior: 'HIDE',
              },
            },
          },
        },
      },
    },
  ],
})
